import { toast } from "react-toastify";

import { track } from "@/features/analytics";
import {
  EXPORT_FORMAT_EXTENSION,
  EXPORT_FORMAT_LABEL,
  type TExportPdfData,
} from "../types";

interface Props {
  pdfData: TExportPdfData;
  url: string;

  auto?: boolean;
}

export const downloadPdf = async ({
  url,
  pdfData,
  auto = false,
}: Props): Promise<{ error?: Error | null }> => {
  track("click download PDF", {
    "pdf url": url,
    "auto download": auto,
  });

  const format = pdfData.format ?? "pdf";
  try {
    const data = await fetch(url);
    if (!data.ok) throw Error(`Failed to fetch PDF: ${data.status}`);
    const blob = await data.blob();
    const objectUrl = URL.createObjectURL(blob);

    const extension = EXPORT_FORMAT_EXTENSION[format];
    const pdfTitle = `${pdfData.version.data?.title ?? pdfData.version._id}.${extension}`;
    const link = document.createElement("a");
    link.setAttribute("href", objectUrl);
    link.setAttribute("download", pdfTitle);

    link.click();
    link.remove();
    // Release the blob once the browser has picked up the download.
    setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
    return { error: null };
  } catch (e) {
    toast.error(`Failed to download ${EXPORT_FORMAT_LABEL[format]}`);
    track("failed PDF download", {
      "pdf url": url,
      "auto download": auto,
      "error message": (e as Error).toString(),
    });

    return { error: e as Error };
  }
};
